<template>
  <div class="field-wrapper">
    <i class="yuzu-icon yuzu-ai"></i>

    <div class="content">
      <span class="title">{{ $t("app.campaign.newPage.aiStep2.title") }}</span>
      <div>
        <span class="yuzuai">{{ $t('app.campaign.newPage.yuzuAI') }}&nbsp;</span>
        <span>{{ $t("app.campaign.newPage.aiStep2.analyzing") }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.field-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  width: 100%;

  .yuzu-icon {
    display: block;
    font-size: 32px;
    width: 32px;
    height: 32px;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    text-align: center;

    .title {
      color: var(--secondary-color);
      text-align: center;
      font-family: $bioSans;
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
}
</style>

<script setup lang="ts">

</script>